$(document).ready(function(){
  $('#modalFormEnquire').prependTo("body");
  $('#modalFormReceiveGuide').prependTo("body");

  jQuery(document).on('click', '.scroll-to', function (e) {
    var id = jQuery(this).attr('href');
    jQuery('html, body').animate({
      scrollTop: jQuery(id).offset().top
    });
    e.preventDefault();
  });

  jQuery(document).on('click', '.checkAgreement', function () {
    var parentForm = jQuery(this).parents('.lp-form');
    if (jQuery(this).prop("checked") == true) {
      jQuery(parentForm).find('input[type="submit"]').attr('disabled', false);
    } else {
      jQuery(parentForm).find('input[type="submit"]').attr('disabled', true);
    }
  });

  jQuery.validator.addMethod("validate_email", function(value, element) {
    if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
      return true;
    } else {
      return false;
    }
  }, "Please enter a valid email address.");

  // New
  // var form_receive_hero = {
  //   form_id: '#formReceive',
  //   hs_portal_id: '26227935',
  //   hs_form_guid: 'd735631d-fdca-4713-89b5-12ad96dc689d',
  //   redirect_url: 'https://bathspacapital.com/pages/thank-you'
  // };

  var form_receive_modal = {
    form_id: '#formReceiveModal',
    hs_portal_id: '26227935',
    hs_form_guid: 'd735631d-fdca-4713-89b5-12ad96dc689d',
    redirect_url: 'https://bathspacapital.com/pages/thank-you'
  };

  var form_enquire_price = {
    form_id: '#formEnquirePrice',
    hs_portal_id: '26227935',
    hs_form_guid: 'c65f2d7f-b2b7-4fac-a667-4c1237aa86eb',
    redirect_url: 'https://bathspacapital.com/pages/thank-you'
  };

  var form_callback = {
    form_id: '#formCallback',
    hs_portal_id: '26227935',
    hs_form_guid: '35a56d59-178b-4cbc-8bfb-daa5d3896ea4',
    redirect_url: 'https://bathspacapital.com/pages/thank-you'
  };
  
  // initializeForm(form_receive_hero, 'default');
  initializeForm(form_receive_modal, 'default');
  initializeForm(form_enquire_price, 'default');
  initializeForm(form_callback, 'callback');
  
  function initializeForm(cform, type) {

    if (type == 'default') {
      $( cform.form_id ).validate({
        rules: {
          FirstName: {
            required: true
          },
          LastName: {
            required: true
          },
          PhoneNumber: {
            required: true,
            number: true,
            // Enable when api is added
            d8val_inttelephone: [
              {
                name: "AllowedPrefixes",
                value: "+44"
              }
            ]
          },
          EmailAddress: {
            required: true,
            validate_email: true
          },
          agreeCheck: {
            required: true
          }
        },
        submitHandler: function(form) {
          var formStepOne = {
            'fields': [
              {
                'name': 'firstname',
                'value':  $( cform.form_id + ' input[name="FirstName"]').val()
              },
              {
                'name': 'lastname',
                'value':  $( cform.form_id + ' input[name="LastName"]').val()
              },
              {
                'name': 'phone',
                'value':  $( cform.form_id + ' input[name="PhoneNumber"]').val()
              },
              {
                'name': 'email',
                'value':  $( cform.form_id + ' input[name="EmailAddress"]').val()
              },
            ],
            'context': {
              // 'hutk': hscookie,
              'pageUri': window.location.href,
              'pageName': 'Gold - Bath Spa Capital'
            }
          };
          
          $.ajax({
            url: 'https://api.hsforms.com/submissions/v3/integration/submit/'+ cform.hs_portal_id + '/' + cform.hs_form_guid,
            type: 'POST',
            contentType: "application/json",
            dataType: "json",
            headers: {
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*'
            },
            data: JSON.stringify(formStepOne),
            beforeSend: function () {
              $(form).find('input[type="submit"]').attr('disabled', true);
            },
            success: function(response) {
              window.location.href = cform.redirect_url;
            },
            complete: function() {
              $(form).find('input[type="submit"]').attr('disabled', false);
            },
            error: function (status, error) {
              // console.log(error, status);
            }
          });
        }
      });
    }
  
    if (type == 'callback') {
      $( cform.form_id ).validate({
        rules: {
          FirstName: {
            required: true
          },
          LastName: {
            required: true
          },
          PhoneNumber: {
            required: true,
            number: true,
            // Enable when api is added
            d8val_inttelephone: [
              {
                name: "AllowedPrefixes",
                value: "+44"
              }
            ]
          },
        },
        submitHandler: function(form) {
          var formStepOne = {
            'fields': [
              {
                'name': 'firstname',
                'value':  $( cform.form_id + ' input[name="FirstName"]').val()
              },
              {
                'name': 'lastname',
                'value':  $( cform.form_id + ' input[name="LastName"]').val()
              },
              {
                'name': 'phone',
                'value':  $( cform.form_id + ' input[name="PhoneNumber"]').val()
              },
            ],
            'context': {
              // 'hutk': hscookie,
              'pageUri': window.location.href,
              'pageName': 'Gold - Bath Spa Capital'
            }
          };
          
          $.ajax({
            url: 'https://api.hsforms.com/submissions/v3/integration/submit/'+ cform.hs_portal_id + '/' + cform.hs_form_guid,
            type: 'POST',
            contentType: "application/json",
            dataType: "json",
            headers: {
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*'
            },
            data: JSON.stringify(formStepOne),
            beforeSend: function () {
              $(form).find('input[type="submit"]').attr('disabled', true);
            },
            success: function(response) {
              window.location.href = cform.redirect_url;
            },
            complete: function() {
              $(form).find('input[type="submit"]').attr('disabled', false);
            },
            error: function (status, error) {
              // console.log(error, status);
            }
          });
        }
      });
    }
  
  }

});